import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Game } from '../types';
import { games } from '../data/games';
import Header from './Header';
import Footer from './Footer';
import GameSection from './GameSection';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function SearchResults() {
  const [searchParams] = useSearchParams();
  const [results, setResults] = useState<Game[]>([]);
  const query = searchParams.get('q') || '';
  const { t } = useTranslation();

  useEffect(() => {
    const filtered = games.filter((game) =>
      game.title.toLowerCase().includes(query.toLowerCase()) ||
      game.description.toLowerCase().includes(query.toLowerCase())
    );
    setResults(filtered);
  }, [query]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header onSearch={() => {}} />
      
      <div className="flex-1 bg-[#1a1625] pt-16">
        <div className="sticky top-16 bg-[#13111d] border-b border-gray-800 z-40">
          <div className="container mx-auto px-4">
            <div className="flex items-center h-12">
              <Link to="/" className="flex items-center space-x-2 text-white hover:text-purple-400">
                <ArrowLeft className="w-5 h-5" />
                <span>Back to Home</span>
              </Link>
            </div>
          </div>
        </div>

        <main className="container mx-auto px-4 py-8">
          <h1 className="text-2xl font-bold text-white mb-8">
            {results.length > 0 ? (
              <>
                {t('search.results_for')} "{query}"
              </>
            ) : (
              <>
                {t('search.no_results')} "{query}". {t('search.try_different')}
              </>
            )}
          </h1>

          {results.length > 0 ? (
            <GameSection 
              title="Search Results" 
              games={results} 
            />
          ) : (
            <div className="bg-[#13111d] rounded-lg p-8 text-center text-white">
              <h2 className="text-xl font-bold mb-4">No games found</h2>
              <p className="text-gray-400 mb-6">
                Try searching with different keywords or browse our game categories
              </p>
              <Link 
                to="/" 
                className="inline-block px-6 py-2 bg-purple-600 rounded-lg hover:bg-purple-700 transition-colors"
              >
                Browse All Games
              </Link>
            </div>
          )}
        </main>
      </div>

      <Footer />
    </div>
  );
} 